
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/agents/reports",
      function () {
        return require("private-next-pages/agents/reports.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/agents/reports"])
      });
    }
  